
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"scaleInput.label":"Maßstab","overviewmap.title":"Übersichtskarte","map.default-projection-warning":"Für diese Karte wurde kein Koordinatensystem konfiguriert. Es wird das Standard-Koordinatensystem verwendet."},"en":{"scaleInput.label":"Scale","overviewmap.title":"Map Overview","map.default-projection-warning":"No coordinate system has been configured for this map. The default coordinate system is used."}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();